import { Injectable } from '@angular/core';
import {
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpInterceptor,
  HttpErrorResponse
} from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { AuthenticationService } from './auth.services';
import { MatSnackBar } from '@angular/material/snack-bar';
import { Router } from '@angular/router';

@Injectable()
export class ErrorInterceptor implements HttpInterceptor {
  constructor(
    private authenticationService: AuthenticationService,
    private snackBar: MatSnackBar,
    private router: Router
  ) {}

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    return next.handle(request).pipe(
      catchError((err: HttpErrorResponse) => {
        if (err.status === 401 && !request.url.includes('/api/auth/signin')) {
          // auto logout if 401 response returned from api
          this.authenticationService.logout();

          // ✅ redirect to login page
          this.router.navigate(['/login']);
        }

        // try to surface the most useful information from the server
        // const error =
        //   // a common custom payload field used across the API
        //   err?.error?.message ||
        //   // fall back to other known shapes
        //   err?.error?.errorMessage ||
        //   err?.error?.errorCode ||
        //   // sometimes the body is an array of errors
        //   err?.error?.[0]?.errorMessage ||
        //   // if the backend sent an object instead of a string, use it whole
        //   err?.error ||
        //   err.statusText;

        

        // Optionally show snack bar
        // this.snackBar.open(error, 'Cancel', {
        //   duration: 3000,
        //   verticalPosition: 'top',
        //   panelClass: 'if-error'
        // });

        return throwError(() => err);
      })
    );
  }
}
